import React from 'react'

const IconLeaderboards = props => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      fill="#28D88C"
      d="M2.6 2h4.5v16.1H2.6zm5.2 3.8h4.5v12.3H7.8zM13 9.5h4.5V18H13z"
    />
    <path
      fill="#09C5B8"
      d="M2.6 10.5h4.5v7.6H2.6zm5.2-1.9h4.5V18H7.8zm5.2 6.6h4.5V18H13z"
    />
  </svg>
);

export default IconLeaderboards



// WEBPACK FOOTER //
// ./src/components/SVG/Navbar/IconLeaderboards.js